export const REQUIRE_READING_NEWER_THAN_DAYS = 5
export const REQUIRE_SMART_READING_NEWER_THAN_DAYS = 1
export const ELEC_FIRST_READ_WINDOW_START_OFFSET = 5
export const ELEC_FIRST_READ_WINDOW_END_OFFSET = 5
export const GAS_FIRST_READ_WINDOW_START_OFFSET = 0
export const GAS_FIRST_READ_WINDOW_END_OFFSET = 10

export const READING_TYPE = {
  CUSTOMER: "Customer",
  SYSTEM: "System",
}
export const METERPOINT_QUERY_STALE_TIME = 2 * 60 * 1000

export const NORMAL_SUPPLY_STATUSES = [
  "Registered",
  "RegistrationCompleted",
  "RegistrationAccepted",
]

export const CAUTION_SUPPLY_STATUSES = [
  "RegistrationWithdrawRejected",
  "LossObjectionRaised",
  "LossObjectionUpheld",
  "RegistrationRequested",
  "RegistrationConfirmed",
  "RegistrationWithdrawing",
  "LossObjected",
  "LossNotified",
  "LossConfirmed",
]

export const ALL_SUPPLY_STATUSES = [
  ...NORMAL_SUPPLY_STATUSES,
  ...CAUTION_SUPPLY_STATUSES,
]

export const STATUS_DISPLAY_NAMES = {
  RegistrationRequested: "Registration Requested",
  RegistrationConfirmed: "Registration Confirmed",
  RegistrationWithdrawRejected: "Withdrawal Rejected",
  RegistrationObjected: "Registration Objected",
  RegistrationWithdrawing: "Withdrawing",
  LossObjected: "Switch Away Objected",
  LossNotified: "Switching Away",
  LossConfirmed: "Switching Away",
  LossObjectionUpheld: "On Supply",
  LossObjectionRaised: "On Supply",
}

export const METER_TYPES = [
  { typeCode: "H", isSmartMeter: false, smetsVersion: null },
  { typeCode: "K", isSmartMeter: false, smetsVersion: null },
  { typeCode: "LAG_", isSmartMeter: false, smetsVersion: null },
  { typeCode: "LEAD_", isSmartMeter: false, smetsVersion: null },
  { typeCode: "MAIN_", isSmartMeter: false, smetsVersion: null },
  { typeCode: "N", isSmartMeter: false, smetsVersion: null },
  { typeCode: "NCAMR", isSmartMeter: false, smetsVersion: null },
  { typeCode: "NSS", isSmartMeter: false, smetsVersion: null },
  { typeCode: "NS", isSmartMeter: false, smetsVersion: null },
  { typeCode: "RCAMR", isSmartMeter: false, smetsVersion: null },
  { typeCode: "RCAMY", isSmartMeter: false, smetsVersion: null },
  { typeCode: "S", isSmartMeter: false, smetsVersion: null },
  { typeCode: "SPECL", isSmartMeter: false, smetsVersion: null },
  { typeCode: "T", isSmartMeter: false, smetsVersion: null },
  { typeCode: "CM", isSmartMeter: false, smetsVersion: null },
  { typeCode: "CR", isSmartMeter: false, smetsVersion: null },
  { typeCode: "ET", isSmartMeter: false, smetsVersion: null },
  { typeCode: "MT", isSmartMeter: false, smetsVersion: null },
  { typeCode: "PP", isSmartMeter: false, smetsVersion: null },
  { typeCode: "TH", isSmartMeter: false, smetsVersion: null },
  { typeCode: "U", isSmartMeter: false, smetsVersion: null },
  { typeCode: "S1", isSmartMeter: true, smetsVersion: 1 },
  { typeCode: "S2", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2A", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2B", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2C", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2AD", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2BD", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2CD", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2ADE", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2BDE", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "S2CDE", isSmartMeter: true, smetsVersion: 2 },
  { typeCode: "CONV", isSmartMeter: false, smetsVersion: null },
]

export const GSP_MAP = new Map([
  ["_A", "Eastern"],
  ["_B", "East Midlands"],
  ["_C", "London"],
  ["_D", "Merseyside and North Wales"],
  ["_E", "Midlands"],
  ["_F", "Northern"],
  ["_G", "North West"],
  ["_H", "Southern"],
  ["_J", "South Eastern"],
  ["_K", "South Wales"],
  ["_L", "South West"],
  ["_M", "Yorkshire"],
  ["_N", "South Scotland"],
  ["_P", "North Scotland"],
])
